/// <reference path="../../../node_modules/@types/jquery/index.d.ts" />
/// <reference path="../positioning/positioning.ts" />
/// <reference path="../storage/storage.ts" />
/// <reference path="../navigation/navigation.ts" />
/// <reference path="../slideorfade/slideorfade.ts" />

namespace Teva {
    export class Accordion {
        static Init() {
            $(document).on("click.accordion", ".og-accordion-link", function () {
                Accordion.Click($(this));
            });
        }
        static PageLoad($Container?) {
            $(".og-accordion[data-accordionid]", $Container).each(function () {
                var $this = $(this);
                if (window.innerWidth <= 850 && $this.data("accordionmode") == "desktop")
                    return;

                var Value = Teva.Storage.LocalStorage_Get("Accordion_" + $this.data("accordionid"));
                if (Value == "0" || Value == "1")
                    $this.toggleClass("og-accordion-open", Value == "1");
            });
            if (window.location.hash != '') {
                var $Accordion = $(".og-accordion[data-accordionid='" + window.location.hash.substring(1) + "']");
                if ($Accordion.length > 0) {
                    $Accordion.addClass("og-accordion-open");
                    Teva.Positioning.ScrollToElement($Accordion);
                }
            }
            $(".og-accordion-open", $Container).each(function () {
                Teva.Accordion.LoadAjax($(this), false, true);
            });
        }

        static LoadAjax($Accordion, Animate, AutoShow, AutoFocus = false) {
            var $Content = $Accordion.find("> .og-accordion-content");
            var $Ajax = $Content.find("> .og-ajax");
            if ($Ajax.length == 0)
                return false;

            var Method = $Ajax.data("ajax-method");
            var URL = $Ajax.data("ajax-url");
            if (Method != "GET") {
                alert("Method not supported: " + Method);
                return false;
            }

            var Data = $Ajax.data("ajax-data");

            $Ajax.remove();
            $(document.createElement('div'))
                .addClass("filter-loading")
                .append($(document.createElement('span')))
                .appendTo($Content);
            if (AutoShow)
                $Accordion.addClass("og-accordion-open");

            $.ajax({
                url: URL,
                data: JSON.stringify(Data),
                contentType: "application/json",
                type: Method,
                success: function (HTML) {
                    if (Animate && $Accordion.hasClass("og-accordion-open")) {
                        var $InnerContent = $(document.createElement('div'))
                            .hide()
                            .html(HTML);
                        $Content.css("min-height", $Content.css("height")).empty().append($InnerContent);
                        Teva.SlideOrFade.Show($InnerContent, 400, function () {
                            Teva.Positioning.StickyTable($InnerContent.find("table"));
                            $Content.css("min-height", "");
                            if ($Accordion.closest(".modal").length == 0)
                                Teva.Positioning.ScrollToElement($Accordion);
                            if ($Accordion.data("accordionid"))
                                Teva.Storage.LocalStorage_Set("Accordion_" + $Accordion.data("accordionid"), "1");
                            if (AutoFocus)
                                Teva.Navigation.FocusOnFirstField($Content);
                        });
                    }
                    else {
                        $Content.html(HTML);
                        Teva.Positioning.StickyTable($Content.find("table"));
                    }
                    $(document).trigger("OfficeGuy.AjaxLoaded", $Content);
                }
            });
            return true;
        }

        static Click($Link): void {
            var $Accordion = $Link.closest(".og-accordion");
            if ($Accordion.hasClass("og-accordion-alwaysopen"))
                return;

            var Content = $Accordion.find("> .og-accordion-content");
            if (Content.queue().length > 0)
                return;
            if ($Accordion.hasClass("og-accordion-open"))
                Teva.Accordion.Hide($Accordion);
            else
                Teva.Accordion.Show($Accordion);
        }
        static Hide($Accordion) {
            if (!$Accordion.hasClass("og-accordion-open"))
                return;

            var $Content = $Accordion.find("> .og-accordion-content");
            Teva.Positioning.RemoveStickyTable($Content.find("table:not(.table-notsticky)"));
            Teva.SlideOrFade.Hide($Content, 400, function () {
                $Accordion.removeClass("og-accordion-open");
                if ($Accordion.data("accordionid"))
                    Teva.Storage.LocalStorage_Set("Accordion_" + $Accordion.data("accordionid"), "0");
            });
        }
        static Show($Accordion, AutoFocus = false) {
            if ($Accordion.hasClass("og-accordion-open")) {
                if (AutoFocus)
                    Teva.Navigation.FocusOnFirstField($Accordion);
                return;
            }

            if (Teva.Accordion.LoadAjax($Accordion, true, true, AutoFocus))
                return;

            var $Content = $Accordion.find("> .og-accordion-content");
            Teva.Positioning.RemoveStickyTable($Content.find("table:not(.table-notsticky)"));
            Teva.SlideOrFade.Show($Content, 400, function () {
                Teva.Positioning.StickyTable($Content.find("table"));
                Teva.Positioning.ScrollToElement($Accordion);
                $Accordion.addClass("og-accordion-open");
                if ($Accordion.data("accordionid"))
                    Teva.Storage.LocalStorage_Set("Accordion_" + $Accordion.data("accordionid"), "1");
                if (AutoFocus)
                    Teva.Navigation.FocusOnFirstField($Accordion);
            });
        }
    }
}

$(document).on("Teva.Init", function () {
    Teva.Accordion.Init();
});
$(document).on("Teva.PageLoad", function () {
    Teva.Accordion.PageLoad();
});

$(document).on("OG.ModalLoading", function (Event, $Container) {
    Teva.Accordion.PageLoad($Container);
});